// C.f. RSMembers.Areas.Brokers.Models.PartnerType enum
export enum PartnerType {
    Broker = 0,
    Aggregator = 1 /* E.g. Connective */,
    Installer = 2,
    Referrer = 3 /* E.g. Purplebricks, Amaysim */
}
